import { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { CalendarGrid } from './calendargrid.jsx'
import { CalendarView } from './index.jsx'

const localStorageKey = 'calendarTabSelection'

export default function CalendarTabsView() {
	const [key, setKey] = useState(
		localStorage.getItem(localStorageKey) ? localStorage.getItem(localStorageKey) : 'calendar',
	)
	const { t } = useTranslation()

	const selectKey = (k) => {
		localStorage.setItem(localStorageKey, k)
		setKey(k)
	}

	return (
		<>
			<h2 className="viewheading">{t('Events', 'Tapahtumat')}</h2>
			<Tabs activeKey={key} onSelect={selectKey} unmountOnExit>
				<Tab eventKey="calendar" title={t('Calendar', 'Kalenteri')}>
					<CalendarView />
				</Tab>
				<Tab eventKey="grid" title={t('Table', 'Taulukko')}>
					<CalendarGrid />
				</Tab>
			</Tabs>
		</>
	)
}
